import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { VariableBenefitConfigurationSubmissionData } from '../../../../../../models/submissions/variable-benefit-configuration-submission-data';
import { VariableBenefitDestinationJurisdictionDetail } from '../../../../../../models/submissions/variable-benefit-destination-jurisdiction-detail';
import { DateConversionUtils } from '../../../../../../utils/date-conversion-utils';
import {
  currentVbPlanYear,
  vbPlanDateFromEffectiveDate
} from '../../../variable-benefit-accounts/utils/vb-annual-details-utils';

interface MinAgeRow {
  jurisdictionName: string;
  personName: string;
  isSpouse: boolean;
  age: number;
  dateOfBirth: string;
}

@Component({
  selector: 'app-vb-config-min-age-review-card',
  templateUrl: './vb-config-min-age-review-card.component.html',
  styleUrls: ['./vb-config-min-age-review-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbConfigMinAgeReviewCardComponent implements OnChanges {
  @Input({ required: true }) submission!: VariableBenefitConfigurationSubmissionData;

  public minAgeRows: MinAgeRow[] = [];

  public ngOnChanges(): void {
    const details = this.submission?.destinationJurisdictions ?? [];
    const planYear =
      vbPlanDateFromEffectiveDate(this.submission?.effectiveDate ?? null)?.planYear ?? currentVbPlanYear();
    this.minAgeRows = details
      .filter(d => !!d.minimumAgeDateOfBirth)
      .map(d => this.toMinAgeRow(d, planYear))
      .sort((a, b) => this.sortKey(a).localeCompare(this.sortKey(b)));
  }

  // Sort alphabetically by jurisdiction name (Alberta first). The Non-Locked-In row has no
  // jurisdiction name, so fall back to its displayed label instead of an empty string —
  // otherwise it would sort ahead of every named jurisdiction.
  private sortKey(row: MinAgeRow): string {
    return row.jurisdictionName || $localize`Non-Locked-In`;
  }

  private toMinAgeRow(detail: VariableBenefitDestinationJurisdictionDetail, planYear: number): MinAgeRow {
    return {
      jurisdictionName: detail.governingJurisdiction?.name ?? '',
      personName: detail.minimumAgeName,
      isSpouse: detail.minimumAgeSpouseId !== null,
      age: DateConversionUtils.calculateAgeOnJanuaryFirst(detail.minimumAgeDateOfBirth, planYear),
      dateOfBirth: detail.minimumAgeDateOfBirth
    };
  }
}
